"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateRangePicker = void 0;
const moment_1 = __importDefault(require("moment"));
const react_1 = __importStar(require("react"));
const react_day_picker_1 = require("react-day-picker");
const react_intl_1 = require("react-intl");
const dateTime_1 = require("../../../utils/dateTime");
const dateTimeFormat_1 = require("../../../utils/dateTimeFormat");
const locale_1 = require("../../../utils/locale");
const DayPicker_1 = require("../DayPicker");
const DayPickerFooter_1 = require("../DayPickerFooter");
const DayPickerWrapper_1 = require("../DayPickerWrapper");
require("./index.scss");
const DateRangePicker = (props) => {
    var _a, _b;
    const { focus, dateRange, onChange, onReset, onClose, numberOfMonths = 2, resetHidden, restrictions, } = props;
    const { locale } = (0, react_intl_1.useIntl)();
    const [hover, setHover] = (0, react_1.useState)({});
    const inputRange = {
        from: dateRange.from ? (0, moment_1.default)(dateRange.from).toDate() : undefined,
        to: dateRange.to ? (0, moment_1.default)(dateRange.to).toDate() : undefined,
    };
    const getMonth = () => {
        var _a;
        const monthsDifference = numberOfMonths ? 1 - numberOfMonths : -1;
        const from = inputRange.from;
        const to = inputRange.to ? react_day_picker_1.DateUtils.addMonths(inputRange.to, monthsDifference) : undefined;
        if (focus === 'from' && from)
            return from;
        if (focus === 'to' && to)
            return to;
        return (_a = from !== null && from !== void 0 ? from : to) !== null && _a !== void 0 ? _a : new Date();
    };
    const range = {
        from: (_a = hover.from) !== null && _a !== void 0 ? _a : inputRange.from,
        to: (_b = hover.to) !== null && _b !== void 0 ? _b : inputRange.to,
    };
    const { from, to } = range;
    const dayPickerProps = {
        className: 'DayPicker--range',
        disabledDays: (0, dateTime_1.getDisabledDays)(restrictions),
        modifiers: { start: from, end: to },
        numberOfMonths,
        onDayClick: (day, modifiers) => {
            var _a;
            if (modifiers.disabled)
                return;
            const outDate = (0, moment_1.default)(day).format(dateTimeFormat_1.DATE_OUTPUT_FORMAT);
            (_a = onChange === null || onChange === void 0 ? void 0 : onChange[focus]) === null || _a === void 0 ? void 0 : _a.call(onChange, outDate);
            const prevFocusData = dateRange[focus === 'from' ? 'to' : 'from'];
            if (prevFocusData) {
                onClose === null || onClose === void 0 ? void 0 : onClose();
            }
        },
        onDayMouseEnter: (date, modifiers) => {
            setHover({
                ...inputRange,
                [focus]: modifiers.disabled ? inputRange[focus] : date,
            });
        },
        onDayMouseLeave: () => {
            setHover({});
        },
        selectedDays: [from, to, { from, to }],
        month: getMonth(),
        locale: (0, locale_1.mapLocaleToLocaleCode)(locale),
    };
    return (react_1.default.createElement(DayPickerWrapper_1.DayPickerWrapper, null,
        react_1.default.createElement(DayPicker_1.DayPicker, { ...dayPickerProps }),
        react_1.default.createElement(DayPickerFooter_1.DayPickerFooter, { resetHidden: resetHidden, onClose: () => {
                onClose === null || onClose === void 0 ? void 0 : onClose();
            }, onResetClick: () => {
                onReset === null || onReset === void 0 ? void 0 : onReset();
                onClose === null || onClose === void 0 ? void 0 : onClose();
            } })));
};
exports.DateRangePicker = DateRangePicker;
//# sourceMappingURL=stable.js.map